export const templateConstants = {
    balanceTemplate: 0,
    incomeTemplate: 1,
    assetsGroupIndex: 0,
    liabilitiesGroupIndex: 1,
    financialStatementMinimumLength: 2,
};
